import * as React from 'react';
import { useDispatch } from 'react-redux';
import { InputTextarea } from '../../../../../brenger-shared-ui';
import { useTypedSelector } from '../../../../../hooks';
import { translate } from '../../../../../utils/localization';
import { getSuspicions } from '../../../../../utils/textScanning';
import { actions } from '../../../ducks';

export type ContactPageError = 'none' | 'address' | 'contact';

interface Props {
  type: 'pickup' | 'delivery';
}

export const AddressInstructionsField: React.FC<Props> = ({ type }) => {
  const instructions = useTypedSelector(state => state.generalTransport.contact[type]?.instructions) || '';
  const dispatch = useDispatch();

  const onBlurInstructions = (): void => {
    const suspicions = getSuspicions(instructions);
    dispatch(actions.setInstructionSuspicion({ stopType: type, suspicions }));
  };

  return (
    <InputTextarea
      value={instructions}
      onChange={i =>
        dispatch(
          actions.setStopAddress({
            stopType: type,
            instructions: i,
          })
        )
      }
      id={`${type}_instructions`}
      placeholder={translate('form.fields.address.instructions.label')}
      autoCompleteDisabled={true}
      onBlur={onBlurInstructions}
    />
  );
};
